import React, { ComponentType, Dispatch, SetStateAction, useMemo, useState } from 'react';
import UploadResumeModal from './UploadResumeModal';
import UploadFile from '../../../common/components/upload/UploadFile';
import { Reference } from '../../../common/reference/reference';
import { BasicInfoInputExtended } from '../detailsPageUtilities/personBasicInformation';
import { useGetAnnotationForId } from './annotationApi';

type FileRendererProps = {
    UploadIconComponent?: ComponentType<any>;
    FileRenderer: ComponentType<any>;
    state?: BasicInfoInputExtended;
    setState?: Dispatch<SetStateAction<BasicInfoInputExtended>>;
    hideUploadResumeIcon?: boolean
};
export default ({
    UploadIconComponent,
    FileRenderer,
    state,
    setState,
    hideUploadResumeIcon=false
}: FileRendererProps) => {
    const entityId = useGetAnnotationForId();
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [entityReference, setEntityReference] = useState<Reference>(undefined);
    const [isUploading, setIsUploading] = useState<boolean>(false);

    const onCloseHandle = () => {
        setSelectedFile(null);
        setEntityReference(undefined);
    };

    const isOpen = useMemo(() => Boolean(selectedFile), [selectedFile]);

    return (
        <>
            {isOpen && (
                <UploadResumeModal
                    isOpen={isOpen}
                    onClose={onCloseHandle}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                    entityReference={entityReference}
                    isUploading={isUploading}
                    setState={setState}
                />
            )}
            <UploadFile
                selectedFile={selectedFile}
                UploadIconComponent={UploadIconComponent}
                setSelectedFile={setSelectedFile}
                setEntityReference={setEntityReference}
                FileRenderer={FileRenderer}
                setIsUploading={setIsUploading}
                fileReference={state?.resumeReference}
                setState={setState}
                entityId={entityId}
                hideUploadResumeIcon={hideUploadResumeIcon}
            />
        </>
    );
};
